// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TIxOR","type":"styles_type__32mJO","choices":"styles_choices__2esvh"};